import { writable } from 'svelte/store';
import type { Page } from '~/jet/models';

export interface ListScreenView {
    detailPage: Page;
    isLoading: boolean;
}

function createStore() {
    const { update, subscribe } = writable<ListScreenView>({
        detailPage: null,
        isLoading: false,
    });

    return {
        subscribe,
        setLoadingState: (selectedId: string) => {
            update((prev: ListScreenView) => ({
                ...prev,
                isLoading: true,
                detailPage: null,
                selectedId,
            }));
        },
        setDetailPage: (detailPage: Page) => {
            update((prev: ListScreenView) => ({
                ...prev,
                isLoading: false,
                detailPage,
            }));
        },
        resetStore: () =>
            update(() => ({
                detailPage: null,
                isLoading: false,
            })),
    };
}

export const listScreenStore = createStore();
export type ListScreenViewStore = typeof listScreenStore;
